import { Injectable } from '@angular/core';
import { AuthService } from '../auth/auth.service';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { UtilsService } from '../shared/utils.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ManufacturerChildGuardService {

  constructor(private authService: AuthService, private router: Router, private utils: UtilsService) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | boolean {
    let canActivate;
    if (this.authService.getUserData().type === this.utils.userTypes.ManufacturerChild && this.router.url.indexOf('manufacturer-users')) {
      canActivate = false;
    } else if (this.authService.getUserData().type === this.utils.userTypes.Manufacturer && this.router.url.indexOf('manufacturer-users')) {
      canActivate = true;
    }
    if (!canActivate) {
      this.router.navigate(['/dashboard']);
    }
    return canActivate;
  }
}
